webpackJsonp([156897593687669],{

/***/ "./src/components/spacer.js":
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var React = _interopRequireWildcard(_react);
	
	var _glamorous = __webpack_require__("./node_modules/glamorous/dist/glamorous.cjs.js");
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var Spacer = function Spacer(_ref) {
		var height = _ref.height,
		    width = _ref.width;
	
		return Glamor.createElement(_glamorous.Div, {
			flex: '0 0 auto',
			style: {
				height: height,
				width: width,
				flex: '0 0 auto'
			}
		});
	};
	
	exports.default = Spacer;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/glamor/react.js")))

/***/ }),

/***/ "./node_modules/babel-loader/lib/index.js?{\"plugins\":[\"C:/Users/Thomas.Beirne/Code/my-website/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"C:/Users/Thomas.Beirne/Code/my-website/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"C:/Users/Thomas.Beirne/Code/my-website/node_modules/babel-plugin-transform-object-assign/lib/index.js\",[\"transform-react-jsx\",{\"pragma\":\"Glamor.createElement\"}],\"glamor/babel-hoist\"],\"presets\":[[\"C:/Users/Thomas.Beirne/Code/my-website/node_modules/babel-preset-env/lib/index.js\",{\"loose\":true,\"uglify\":true,\"modules\":\"commonjs\",\"targets\":{\"browsers\":[\"> 1%\",\"last 2 versions\",\"IE >= 9\"]},\"exclude\":[\"transform-regenerator\",\"transform-es2015-typeof-symbol\"]}],\"C:/Users/Thomas.Beirne/Code/my-website/node_modules/babel-preset-stage-0/lib/index.js\",\"C:/Users/Thomas.Beirne/Code/my-website/node_modules/babel-preset-react/lib/index.js\"],\"cacheDirectory\":true}!./src/pages/resume.js":
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _glamorous = __webpack_require__("./node_modules/glamorous/dist/glamorous.cjs.js");
	
	var _spacer = __webpack_require__("./src/components/spacer.js");
	
	var _spacer2 = _interopRequireDefault(_spacer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Resume = function Resume() {
	  return Glamor.createElement(
	    _glamorous.Div,
	    { maxWidth: "900px" },
	    Glamor.createElement(
	      _glamorous.H1,
	      { marginTop: "0" },
	      "Resume"
	    ),
	    Glamor.createElement(
	      "style",
	      null,
	      "\n        .job-time {\n          float: right;\n          font-size: 0.7em;\n          font-weight: 400;\n          line-height: 1.5;\n        }\n      "
	    ),
	    Glamor.createElement(
	      "h2",
	      null,
	      "Why you should care"
	    ),
	    "I perpetually seek out new ways to be better at what I do. I delight in the low-level details of how complex (or better yet, unexpectedly simple) software systems work. I take pride in helping others to grow and in being spurred on to growth by them. I strive to build elegant useful products that put users first. I'm smart and I get things done.",
	    Glamor.createElement(
	      _glamorous.Div,
	      { display: "flex" },
	      Glamor.createElement(
	        _glamorous.Div,
	        { flex: "1 0 0%" },
	        Glamor.createElement(
	          "h2",
	          null,
	          " Programming languages "
	        ),
	        Glamor.createElement(
	          _glamorous.Ul,
	          { paddingLeft: "20px", marginBottom: "0" },
	          Glamor.createElement(
	            "li",
	            null,
	            " JavaScript (very competent) "
	          ),
	          Glamor.createElement(
	            "li",
	            null,
	            "C# (bit rusty)"
	          ),
	          Glamor.createElement(
	            "li",
	            null,
	            "ClojureScript, Java, Python, Ruby, and C++ (all cursory familiarity only)"
	          )
	        )
	      ),
	      Glamor.createElement(_spacer2.default, { width: 20 }),
	      Glamor.createElement(
	        _glamorous.Div,
	        { flex: "1 0 0%" },
	        Glamor.createElement(
	          "h2",
	          null,
	          "Technologies"
	        ),
	        Glamor.createElement(
	          _glamorous.Ul,
	          { paddingLeft: "20px", marginBottom: "0" },
	          Glamor.createElement(
	            "li",
	            null,
	            "Node.js, Hapi, Webpack, Browserify"
	          ),
	          Glamor.createElement(
	            "li",
	            null,
	            "Mocha, Jasmine, Chai, ESLint, Gulp"
	          ),
	          Glamor.createElement(
	            "li",
	            null,
	            "Stylus, Less, SASS"
	          ),
	          Glamor.createElement(
	            "li",
	            null,
	            "Docker, Nginx, AWS"
	          )
	        )
	      )
	    ),
	    Glamor.createElement(
	      "h2",
	      { style: { clear: "both" } },
	      "Experience"
	    ),
	    Glamor.createElement(
	      "h3",
	      null,
	      "Blossor ",
	      Glamor.createElement(
	        "div",
	        { className: "job-time" },
	        "(Mar 2014\u2014Dec 2014)"
	      )
	    ),
	    "I was the sole front-end developer for Blossor.com, a real estate search portal. I architected and implemented an isomorphic JavaScript application using Node.js, hapi, React, and Fluxxor.",
	    Glamor.createElement(
	      "ul",
	      null,
	      Glamor.createElement(
	        "li",
	        null,
	        "Ran trainings on JavaScript and Git."
	      ),
	      Glamor.createElement(
	        "li",
	        null,
	        "Coordinated with leadership and graphic design departments on feature designs."
	      ),
	      Glamor.createElement(
	        "li",
	        null,
	        "Set up continuous integration with Circle CI and AWS using Docker."
	      )
	    ),
	    Glamor.createElement(
	      "h3",
	      null,
	      "Faithlife ",
	      Glamor.createElement(
	        "div",
	        { className: "job-time" },
	        "(Jun 2010\u2014Mar 2014)"
	      )
	    ),
	    "I worked on a variety of projects and teams using ASP.NET MVC, C#, JavaScript, and Sencha Touch for Faithlife, a worldwide leader in electronic tools and resources for Bible study. I led a team of 3-4 developers from Nov 2012 - Aug 2013 working on the Faithlife social network.",
	    Glamor.createElement(
	      "ul",
	      null,
	      Glamor.createElement(
	        "li",
	        null,
	        "Oversaw the development and deployment of Biblia.com (a single-page web app written in C# and JS) as it went from from 450,000 monthly users to more than 990,000."
	      ),
	      Glamor.createElement(
	        "li",
	        null,
	        "Spearheaded changing my team\u2019s version control workflow to emphasize code review."
	      ),
	      Glamor.createElement(
	        "li",
	        null,
	        "Improved documentation of coding guidelines for the web development teams."
	      ),
	      Glamor.createElement(
	        "li",
	        null,
	        "Architected and wrote a \u201CProclaim Remote\u201D Sencha Touch app in JS for iOS and Android that allowed users to control a presentation from their phone."
	      )
	    ),
	    Glamor.createElement(
	      "h2",
	      null,
	      "Education"
	    ),
	    Glamor.createElement(
	      "div",
	      null,
	      Glamor.createElement(
	        "b",
	        null,
	        "Bachelor of Science"
	      ),
	      " in Computer Science, WWU",
	      Glamor.createElement(
	        "i",
	        null,
	        "3.96 GPA \u2014 June 2010"
	      )
	    ),
	    Glamor.createElement(
	      "div",
	      null,
	      Glamor.createElement(
	        "b",
	        null,
	        "Associate of Science"
	      ),
	      ", SPSCC",
	      Glamor.createElement(
	        "i",
	        null,
	        "4.00 GPA \u2014 June 2007"
	      )
	    ),
	    Glamor.createElement(
	      "div",
	      null,
	      Glamor.createElement(
	        "b",
	        null,
	        "High school diploma"
	      ),
	      ", New Market Skills Center",
	      Glamor.createElement(
	        "i",
	        null,
	        "4.00 GPA \u2014 June 2007"
	      )
	    ),
	    Glamor.createElement(
	      "ul",
	      null,
	      Glamor.createElement(
	        "li",
	        null,
	        "National Merit Scholar"
	      ),
	      Glamor.createElement(
	        "li",
	        null,
	        "Placed 3rd at national SkillsUSA computer networking competition"
	      )
	    ),
	    Glamor.createElement(
	      "h2",
	      null,
	      "Contact"
	    ),
	    Glamor.createElement(
	      "a",
	      { href: "mailto:thomas.beirne@gmail.com" },
	      "thomas.beirne@gmail.com"
	    )
	  );
	};
	
	exports.default = Resume;
	module.exports = exports["default"];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/glamor/react.js")))

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-resume-js-dda2d8d7e9af61bff985.js